module.exports = __webpack_public_path__ + "img/勾选拷贝9@2x.29f4bfda.png";